import React, { useEffect, useState } from 'react';
import './Services.css';
import ServicesComponent from '../components/Services/Services';
import projectImg1 from '../assets/Project/project_6.jpg';
import workImg1 from '../assets/Work/Work_1.jpg';
import PricingPlans from '../components/PricingPlans/PricingPlans';
import { Link } from 'react-router-dom';
import Aos from 'aos';

const Services = () => {
  useEffect(() => {
    // Force window to scroll to the very top instantly when the component mounts
    window.scrollTo(0, 0);
    Aos.init({ duration: 1000, once: true });
  }, []);
  const [activeTab, setActiveTab] = useState("construction");

  const steps = [
    { num: "01", title: "Planning & Consultation", desc: "We follow primary goal by defining scope, finalizing design, and securing necessary approvals." },
    { num: "02", title: "Design & Engineering", desc: "Detailed structural designs and site-specific solutions." },
    { num: "03", title: "Construction Execution", desc: "Follow a structured path from initial planning to final handover." },
    { num: "04", title: "Inspection & Handover", desc: "Deficiencies are Identified & resolved followed by the handover." }
  ];

  const tabContent = {
    construction: {
      title: "Expert Quality in Construction",
      subtitle: "Delivering durable, high-quality structures built to last.",
      points: ["Superior Material Selection", "Skilled Engineering", "On-time Delivery", "Cost-Effective", "Quality Control", "Reliability"],
    },
    process: {
      title: "Efficient Process",
      subtitle: "A streamlined construction workflow from planning to handover.",
      points: ["Detailed Planning", "Transparent Costs", "Regular Inspections", "Progress Reporting", "Risk Management", "Smooth Handover","Proper communication"],
    },
    safety: {
      title: "Safety & Trust",
      subtitle: "Building with responsibility, safety, and long-term trust.",
      points: ["Safety Protocols", "Certified Equipment", "Compliance Standards", "Insured Workforce", "Zero-Tolerance", "Client Trust"],
    },
  };

  const content = tabContent[activeTab];

  return (
    <div className="services-page">
      {/* HERO SECTION */}
      <section className="services-hero-container">
        <div className="hero-overlay">
          <div className="container text-center">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-center">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active text-white" aria-current="page">Services</li>
              </ol>
            </nav>
            <h1 className="display-3 fw-bold text-white">Services</h1>
            <div className="yellow-divider mx-auto my-3"></div>
            <p className="lead text-light mt-3 mx-auto" style={{ maxWidth: '800px' }}>
              Construction is the process of planning, designing, and building infrastructure 
              such as residential homes, commercial and industrial facilities.
            </p>
          </div>
        </div>
      </section>

      <ServicesComponent />

      {/* WHY CHOOSE US */}
      <section className="why-choose-us py-5">
        <div className="container text-center text-white pt-5">
          <p className="text-uppercase small-accent">Why Choose Us</p>
          <h2 className="fw-bold mb-4">Your Trusted Construction Partner</h2>
          <div className="d-flex justify-content-center gap-3 mb-5 flex-wrap">
            {Object.keys(tabContent).map((tab) => (
              <button
                key={tab}
                className={`quality-tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)} Quality
              </button>
            ))}
          </div>

          <div className="row align-items-center text-start mt-5 g-5">
            <div className="col-lg-6">
              <div className="feature-image-wrapper">
                <img src={projectImg1} alt="Quality" className="img-fluid rounded-3" />
              </div>
            </div>
            <div className="col-lg-6">
              <h3 className="fw-bold mb-3">{content.title}</h3>
              <p className="service-subtext p-3 mb-4">{content.subtitle}</p>
              <div className="row g-3">
                {content.points.map((item, idx) => (
                  <div className="col-md-6" key={idx}>
                    <p className="check-item"><i className="bi bi-check2 me-2"></i> {item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WORK PROCESS */}
      <section className="work-process py-5 bg-white">
        <div className="container text-center py-5">
          <p className="text-uppercase small-accent-dark">Work Process</p>
          <h2 className="fw-bold mb-5">Our Construction Work Process</h2>
          <div className="row g-4 mt-4">
            {steps.map((step, idx) => (
              <div className="col-lg-3 col-md-6" key={idx}>
                <div className="process-card p-4">
                  {/* Badge sits on top of card */}
                  <div className="step-badge">{step.num}</div>
                  <div className="process-img-holder mb-4">
                     <img src={workImg1} alt={step.title} className="img-fluid" />
                  </div>
                  <h5 className="fw-bold">{step.title}</h5>
                  <p className="text-muted small">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <PricingPlans />
    </div>
  );
};

export default Services;